import membership from "../data/indexMembership.json";

export type IndexId = "NDX" | "SPX";

const NDX = new Set((membership.NDX as string[]).map((t) => t.toUpperCase()));
const SPX = new Set((membership.SPX as string[]).map((t) => t.toUpperCase()));

/** Sorted S&P 500 universe used by Puts+. */
export function spxTickers(): string[] {
  return [...SPX].sort();
}

/** Index badges for a ticker, NDX then SPX (matches web screener chip order). */
export function indexesForTicker(ticker: string): IndexId[] {
  const key = ticker.trim().toUpperCase();
  if (!key) return [];
  const out: IndexId[] = [];
  if (NDX.has(key)) out.push("NDX");
  if (SPX.has(key)) out.push("SPX");
  return out;
}

/** Native index_badges codes when API omits them. */
export function indexBadgesForTicker(ticker: string): string[] {
  const ids = indexesForTicker(ticker);
  const out: string[] = [];
  if (ids.includes("SPX")) out.push("sp500");
  if (ids.includes("NDX")) out.push("ndx");
  return out;
}

function esc(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

export function indexBadgeLabel(code: string): string {
  if (code === "sp500") return "SPX";
  if (code === "ndx") return "NDX";
  if (code === "dji") return "DJI";
  if (code === "rut") return "RUT";
  return code.toUpperCase();
}

export function indexBadgeClass(code: string): string {
  if (code === "sp500") return "idx-sp500";
  if (code === "ndx") return "idx-ndx";
  if (code === "dji") return "idx-dji";
  if (code === "rut") return "idx-rut";
  return "";
}

/** Compact vertical index badges beside ticker (puts/calls + native wheel tables). */
export function renderIndexBadgesHtml(badges: string[] | undefined): string {
  if (!badges?.length) return "";
  const chips = badges
    .map((code) => {
      const label = indexBadgeLabel(code);
      const cls = indexBadgeClass(code);
      return `<span class="idx-mini ${cls}" title="${esc(label)}">${esc(label)}</span>`;
    })
    .join("");
  return `<span class="tk-badges tk-badges-stack">${chips}</span>`;
}
